import BaseModel from "../models/BaseModel";
import BaseModelMap from "../models/BaseModelMap";
import { CableType } from "../models/CableType";
import { itx } from "../translationItx/itx";
import TreeViewModel from "../models/TreeviewModel";

export default class CableTypesTreeViewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): BaseModelMap<CableType> {
    return this.obj as BaseModelMap<CableType>;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    return state.cableTypes.sortBy("tag");
  }

  handleAdd() {
    try {
      const newCabelType = new CableType({}, this.typedObj);
      newCabelType.numberOfWires = 5;
      newCabelType.tag = `C${this.typedObj.size + 1}`;
      newCabelType.name = `5x1.5 New`;

      this.typedObj.add(newCabelType);
      state.activePanes.activatePane(newCabelType.id);
      state.selectionManager.selectedObject = newCabelType;
    } catch (ex) {
      console.error(ex);
    }
  }

  getButtons(): JSX.Element[] | undefined {
    return [super.inlineButton_Add("cableTypesTreeViewModel.addCableType")];
  }
}
